import React, { useState } from 'react';
import { Modal, View } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import FormActions from '../../../components/FormActions';
import { WindowInformation } from '../../../services/window-information';
import { dispatchService } from '../../../services/central-api/dispatch';
import ActingBodiesDropdown from '../OccurrenceTypes/ActingBodiesDropdown';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { useAuth } from '../../../context/Auth';

export default function TeamProgramsModal({ onClose, unitProgram, isModalVisible }: { onClose: () => void; unitProgram?: UnitProgram; isModalVisible: boolean; }) {
    const { user: authenticatedUser } = useAuth();
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [name, setName] = useState(unitProgram?.name || '');
    const [actingBodyId, setActingBodyId] = useState<number>(unitProgram?.actingBodyId ?? 0);

    function isNameInvalid(value: string) {
        return value == '';
    }

    function isFormValid() {
        return !isNameInvalid(name);
    }

    function clearValues() {
        setName('');
    }

    async function formSubmit() {
        try {
            if (unitProgram?.id) {
                await dispatchService.updateUnitProgram({
                    id: unitProgram.id,
                    name: name
                });
                onClose();
                return;
            }

            await dispatchService.createUnitProgram({
                name: name,
                actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined
            });
            onClose();
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <Modal transparent={true} visible={isModalVisible} animationType='fade' onRequestClose={() => {
            onClose();
            clearValues();
        }}>
            <View style={styles.modalContainer}>
                <View style={styles.centeredView}>
                    <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : { width: '20%' }]}>
                        {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_programs) &&
                            <ActingBodiesDropdown includeAllOption={false} value={actingBodyId} setValue={setActingBodyId} zIndex={2} disabled={!!unitProgram?.id} />
                        }

                        <FormInput
                            label={translate('name')}
                            placeholder={translate('name')}
                            value={name}
                            onChangeText={setName}
                            invalid={isNameInvalid}
                        />

                        <FormActions
                            onSubmit={formSubmit}
                            onClose={onClose}
                            disabled={!isFormValid()} />
                    </View>
                </View>
            </View>
        </Modal >
    );
}

const styleSheet = createStyleSheet((theme) => ({
    formContainer: {
        minWidth: 300,
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25
    },
    modalContainer: {
        flex: 1,
        backgroundColor: '#31313199'
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonsContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: 10,
    },
}));
